import { createFileRoute } from '@tanstack/react-router';
import { BillsPage } from '../../features/billing-docs';

export const Route = createFileRoute('/portal/bills/')({ component: BillsPage });
